module.exports = __webpack_public_path__ + "08_long_brown.526f60a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/08_long_brown.png
// module id = R2o7
// module chunks = 0